<template>
  <v-container id="configuracionrest" tag="section">
    <base-v-component heading="Configuración restaurante " />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <template v-slot:heading>
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          slider-color="white"
        >
          <v-tab class="mr-3">
            <v-icon class="mr-2">mdi-shield</v-icon>General
          </v-tab>
          <v-tab class="mr-3" v-if="isAdmin">
            <v-icon class="mr-2">mdi-email</v-icon>Emails
          </v-tab>
          <v-tab class="mr-3" v-if="isAdmin">
            <v-icon class="mr-2">mdi-printer</v-icon>Dispositivos
          </v-tab>
          <v-tab class="mr-3" v-if="isAdmin">
            <v-icon class="mr-2">mdi-pencil</v-icon>Personalización
          </v-tab>

          <v-tab class="mr-3" v-if="isAdmin">
            <v-icon class="mr-2">mdi-desktop-classic</v-icon>Neo
          </v-tab>
          <v-spacer />
        </v-tabs>
      </template>
      <v-tabs-items v-model="tabs" class="transparent">
        <v-tab-item key="0">
          <!--general-->
          <v-toolbar flat color="white">
            <v-spacer />
            <v-btn
              color="primary"
              dark
              class="mb-2"
              :loading="loadingFormConfGeneral"
              @click="saveGeneral"
              >Guardar</v-btn
            >
          </v-toolbar>
          <v-row>
            <v-col cols="12" sm="2">
              <v-checkbox
                v-model="general.aceptaFormContacto"
                label="Formulario"
              />
            </v-col>
            <v-col cols="12" sm="2">
              <v-checkbox
                v-model="general.noAutomatizarHorario"
                label="Anular automatización"
              />
            </v-col>
            <v-col cols="12" sm="2">
              <v-checkbox
                v-model="general.proximamente"
                label="Marcar como próximamente"
              />
            </v-col>
            <v-col cols="12" sm="2" v-if="general.proximamente">
              <v-text-field
                v-model="general.proximamenteTexto"
                label="Texto próximamente"
              />
            </v-col>
            <v-col cols="12" sm="2" v-if="general.proximamente">
              <v-text-field
                v-model="general.imprimirTpvLocal"
                label="Imprimir en TPV local"
              />
            </v-col>
            <v-col cols="12" sm="2">
              <v-checkbox
                v-model="general.aceptaReserva"
                label="Acepta reservas"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                type="number"
                step="5"
                label="Tiempo domicilio"
                v-model="general.tiempoDomicilio"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                type="number"
                step="5"
                label="Tiempo recoger"
                v-model="general.tiempoRecoger"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-autocomplete
                item-value="timezone"
                :items="$store.state.app.zonasHorarias"
                label="Zona horaria"
                v-model="general.zonaHoraria"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                multiple
                v-model="general.modoPedir"
                :items="$store.state.restaurantes.modoPedir"
                label="Modos pedidos disponibles"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                multiple
                v-model="general.formasPagoDomicilio"
                :items="$store.state.restaurantes.formasPagoDomicilio"
                label="Formas de pago domicilio"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                multiple
                v-model="general.formasPagoRecoger"
                :items="$store.state.restaurantes.formasPagoRecoger"
                label="Formas de pago recogida"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                multiple
                v-model="general.formasPagoDomicilioEfectivoAcepta"
                :items="
                  $store.state.restaurantes.formasPagoDomicilioEfectivoAcepta
                "
                label="Billetes efectivo para cambio domicilio"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item key="1">
          <!--emails-->
          <v-toolbar flat color="white">
            <v-spacer />
            <v-btn
              color="primary"
              dark
              class="mb-2"
              :loading="emails.loadingForm"
              @click="saveEmails"
              >Guardar</v-btn
            >
          </v-toolbar>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="emailNotComputados"
                label="Emails notificaciones"
                placeholder="Separados por comas"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="emailInternosComputados"
                label="Emails pedidos internos"
                placeholder="Separados por comas"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="emailContactoComputados"
                label="Emails formulario de contacto"
                placeholder="Separados por comas"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="emailReservasComputados"
                label="Emails reservas"
                placeholder="Separados por comas"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="emailZcierreComputados"
                label="Emails z cierre"
                placeholder="Separados por comas"
              />
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item key="2">
          <v-toolbar flat color="white">
            <v-spacer />
            <v-btn
              color="primary"
              dark
              class="mb-2"
              :loading="loadingForm"
              @click="saveOrdenador"
              >Guardar</v-btn
            >
          </v-toolbar>
          <v-autocomplete
            multiple
            item-value="id"
            item-text="mostrarSelect"
            v-model="ordenadoresSeleccionados"
            :items="ordenadoresNegocio"
          />
          <!--impresoras-->
          <v-toolbar flat color="white">
            <v-btn color="success" dark class="mb-2" @click="addImpPush"
              >Añadir impresora - ticket</v-btn
            >
            <v-spacer />
            <v-btn color="primary" dark class="mb-2" @click="save"
              >Guardar</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-row v-for="(d, i) in datos" :key="i">
                <v-col cols="4">
                  <v-select
                    label="ticket"
                    item-value="id"
                    item-text="nombre"
                    v-model="d.ticket"
                    :items="tickets"
                  />
                </v-col>
                <v-col cols="4">
                  <v-autocomplete
                    label="impresoras"
                    item-value="id"
                    v-model="d.impresora"
                    item-text="mostrarSelect"
                    :items="impresoras"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select v-model="d.copias" label="Copias" :items="copias" />
                </v-col>
                <v-col cols="1">
                  <v-btn text @click="removeImp(i)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-tab-item>
        <!--PERSONALIZACIÓN-->
        <v-tab-item key="3">
          <v-toolbar flat color="white">
            <v-spacer />
            <v-btn
              color="primary"
              :loading="loadingFormPersonalizacion"
              dark
              class="mb-2"
              @click="savePersonalizacion"
              >Guardar</v-btn
            >
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-row align="center">
                <v-col cols="12" sm="4">
                  <v-row class="mx-2">
                    <p class="text-center subtitle-1">
                      Imagen listado restaurante
                    </p>
                    <v-spacer />
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="red mr-4"
                      v-if="personalizacion.imagenRestListado"
                      @click="personalizacion.imagenRestListado = ''"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                      :loading="loadingImagenAux"
                      small
                      class="secondary"
                      @click="cambiarImagen('imagenRestListado')"
                    >
                      <v-icon>mdi-reload</v-icon>
                    </v-btn>
                    <v-file-input
                      class="d-none"
                      ref="imagenRestListado"
                      color="deep-purple accent-4"
                      counter
                      label="File input"
                      placeholder="Select your files"
                      prepend-icon="mdi-paperclip"
                      outlined
                      v-model="imagenAux"
                      @change="cambiarImagenFichero('personalizacion')"
                      :show-size="1000"
                    />
                  </v-row>
                  <v-img
                    :src="personalizacion.imagenRestListado"
                    max-height="150px"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-text-field
                    v-model="personalizacion.pedirOnlineCustom"
                    label="Enlace pedir personalizado"
                  />
                </v-col>
                <v-col cols="12" sm="4">
                  <v-checkbox
                    v-model="personalizacion.mostrarFichaTlf"
                    label="Mostrar teléfono"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-tab-item>
        <v-tab-item key="4">
          <!--neo-->
          <v-toolbar flat color="white">
            <v-spacer />
            <v-btn
              color="primary"
              dark
              class="mb-2"
              :loading="showNeo.loadingForm"
              @click="saveNeo"
              >Guardar</v-btn
            >
          </v-toolbar>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="datosNeo.url"
                :append-icon="showNeo.url ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNeo.url ? 'text' : 'password'"
                @click:append="showNeo.url = !showNeo.url"
                label="Url"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="datosNeo.centro"
                :append-icon="showNeo.centro ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNeo.centro ? 'text' : 'password'"
                @click:append="showNeo.centro = !showNeo.centro"
                label="centro"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                v-model="datosNeo.apikey"
                :append-icon="showNeo.apikey ? 'mdi-eye' : 'mdi-eye-off'"
                :type="showNeo.apikey ? 'text' : 'password'"
                @click:append="showNeo.apikey = !showNeo.apikey"
                label="Api Key"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4">
              <v-btn
                :loading="loadingBtnNeo"
                secondary
                @click="actualizarPreciosNeo"
                >Actualizar precios ahora</v-btn
              >
            </v-col>
            <v-col cols="12" sm="4"
              >Fecha última actualización:
              {{ fechaActualizacionCorregida }}</v-col
            >
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import moment from "moment-timezone";
var _ = require("lodash");
export default {
  data() {
    return {
      imagenAux: null, //para subir imágenes
      loadingImagenAux: false,
      loadingFormPersonalizacion: false,
      loadingForm: false,
      datos: [], //se refiere a las impresoras
      tabs: 0,
      ordenadoresSeleccionados: [],
      loadingBtnNeo: false,
      datosNeo: {
        url: "https://apis.bartolomeconsultores.com/pedidosonline/",
        apikey: "",
        centro: "",
        fechaActualizacion: null,
      },
      showNeo: {
        centro: false,
        apikey: false,
        url: true,
        loadingForm: false,
      },
      loadingFormConfGeneral: false,
      personalizacion: {
        imagenRestListado: "",
        imagenRest: "",
        pedirOnlineCustom: "",
        mostrarFichaTlf: false,
      },
      general: {
        zonaHoraria: "",
        aceptaFormContacto: null,
        aceptaReservas: false,
        tiempoDomicilio: 15,
        tiempoRecoger: 15,
        formasPagoDomicilio: [],
        formasPagoRecoger: [],
        noAutomatizarHorario: false,
        proximamente: false,
        imprimirTpvLocal: false,
        proximamenteTexto: "",
        modoPedir: [],
      },
      emails: {
        notificaciones: [],
        internos: [],
        id: null,
        contacto: [],
        reservas: [],
        zcierre: [],
        nombre: "",
        loadingForm: false,
      },
    };
  },
  computed: {
    fechaActualizacionCorregida() {
      let restObj = this.$store.getters["app/restGestObj"];
      return this.datosNeo.fechaActualizacion
        ? moment(this.datosNeo.fechaActualizacion.toDate())
            .tz(restObj.confGeneral.zonaHoraria)
            .format("DD-MM-YYYY HH:mm")
        : "";
    },
    emailInternosComputados: {
      get() {
        return this.emails.internos ? this.emails.internos.toString() : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.emails.internos = val.split(expresionRegular);
      },
    },
    emailReservasComputados: {
      get() {
        return this.emails.reservas ? this.emails.reservas.toString() : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.emails.reservas = val.split(expresionRegular);
      },
    },
    emailZcierreComputados: {
      get() {
        return this.emails.zcierre ? this.emails.zcierre.toString() : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.emails.zcierre = val.split(expresionRegular);
      },
    },
    emailContactoComputados: {
      get() {
        return this.emails.contacto ? this.emails.contacto.toString() : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.emails.contacto = val.split(expresionRegular);
      },
    },
    emailNotComputados: {
      get() {
        return this.emails.notificaciones
          ? this.emails.notificaciones.toString()
          : "";
      },
      set(val) {
        var expresionRegular = /\s*,\s*/;
        this.emails.notificaciones = val.split(expresionRegular);
      },
    },
    ...mapState({
      tickets: (state) => state.tickets.ticketsArray,
      copias: (state) => state.tickets.copiasArray,
    }),
    ...mapGetters({
      impresoras: "restaurantes/getSelectImpresoras",
      isAdmin: "auth/isAdmin",
      ordenadoresNegocio: "negocios/getSelectOrdenadores",
    }),
  },
  methods: {
    savePersonalizacion() {
      const _vm = this;
      _vm.loadingFormPersonalizacion = true;
      this.$store
        .dispatch("restaurantes/savePersonalizacion", {
          personalizacion: this.personalizacion,
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Personalización grabada con éxito",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la personalización: " + error,
          });
        })
        .finally(() => {
          _vm.loadingFormPersonalizacion = false;
        });
    },
    cambiarImagen(s) {
      this.imagenCambiando = s;
      this.$refs[s].$refs.input.click();
    },
    cambiarImagenFichero(pagina = false) {
      let _vm = this;
      _vm.loadingImagenAux = true;
      console.log(pagina);
      this.$store
        .dispatch("propio/subirImagen", {
          //tipo: this.imagenCambiando,
          imagen: this.imagenAux,
          restaurante: this.$store.getters["app/restGestObj"].id,
        })
        .then((img) => {
          if (pagina) {
            const array = pagina.split("/");
            let aux = this;
            array.forEach((e) => {
              aux = aux[e];
            });
            aux[this.imagenCambiando] = img;
          } else {
            this.general[this.imagenCambiando] = img;
          }
          console.log(this);
        })
        .finally(() => (_vm.loadingImagenAux = false));
    },
    addImpPush() {
      let aux = {
        ticket: null,
        impresora: null,
        copias: 1,
      };
      this.datos.push(aux);
    },
    addImp() {
      let d = this.datos;
      return this.$store.dispatch("restaurantes/addImpresorasTickets", d);
    },
    addOrdenador() {
      let d = this.ordenadoresSeleccionados;
      return this.$store.dispatch("restaurantes/addOrdenadores", d);
    },
    getTickets() {
      return this.$store.dispatch("restaurantes/getImpresorasTickets");
    },
    getOrdenadores() {
      return this.$store.dispatch("restaurantes/getOrdenadores");
    },
    saveOrdenador() {
      let _vm = this;
      this.loadingForm = true;
      this.addOrdenador()
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Configuración grabada con éxito",
          });
          _vm.getOrdenadores();
          _vm.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la configuración",
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
    },
    save() {
      let _vm = this;
      //this.$v.$touch();
      //if (!this.$v.$invalid) {
      this.loadingForm = true;
      this.addImp()
        .then((res) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Configuración grabada con éxito",
          });
          _vm.getTickets();
          _vm.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la configuración",
          });
        })
        .finally(() => {
          _vm.loadingForm = false;
        });
      //}
    },
    removeImp(i) {
      console.log(this.datos);
      _.pullAt(this.datos, i);
      this.$forceUpdate();
      console.log(this.datos);
    },
    saveGeneral() {
      const _vm = this;
      _vm.loadingFormConfGeneral = true;
      this.$store
        .dispatch("restaurantes/saveConfGeneral", {
          confGeneral: this.general,
          tiempoDomicilio: this.general.tiempoDomicilio,
          tiempoRecogida: this.general.tiempoRecoger,
          formasPagoDomicilio: this.general.formasPagoDomicilio,
          formasPagoRecoger: this.general.formasPagoRecoger,
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Configuración grabada con éxito",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar la configuración: " + error,
          });
        })
        .finally(() => {
          _vm.loadingFormConfGeneral = false;
        });
    },
    saveEmails() {
      const _vm = this;
      _vm.emails.loadingForm = true;
      console.log(this.emails);
      this.$store
        .dispatch("restaurantes/saveEmails", {
          emails: {
            internos: this.emails.internos ? this.emails.internos : [],
            reservas: this.emails.reservas ? this.emails.reservas : [],
            zcierre: this.emails.zcierre ? this.emails.zcierre : [],
            notificaciones: this.emails.notificaciones
              ? this.emails.notificaciones
              : [],
            contacto: this.emails.contacto ? this.emails.contacto : [],
          },
        })
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Emails grabados con éxito",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los emails: " + error,
          });
        })
        .finally(() => {
          _vm.emails.loadingForm = false;
        });
    },
    saveNeo() {
      const _vm = this;
      _vm.showNeo.loadingForm = true;
      this.$store
        .dispatch("restaurantes/saveNeo", this.datosNeo)
        .then((r) => {
          _vm.$store.commit("snackbar/setMensajeSuccess", {
            msj: "Datos neo grabados con éxito",
          });
        })
        .catch((error) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: "Error al guardar los datos neo: " + error,
          });
        })
        .finally(() => {
          _vm.showNeo.loadingForm = false;
        });
    },
    getNeo() {
      this.$store.dispatch("restaurantes/getNeo").then((r) => {
        if (r) this.datosNeo = r;
      });
    },
    actualizarPreciosNeo() {
      let _vm = this;
      _vm.loadingBtnNeo = true;
      _vm.$store
        .dispatch("restaurantes/actualizarNeoRestaurante")
        .then((res) => {
          let r = res.data;
          if (r.ok) {
            _vm.getNeo();
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Productos Neo volcados",
            });
          } else {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: r.error,
            });
          }
        })
        .catch((e) => {
          _vm.$store.commit("snackbar/setMensajeDanger", {
            msj: e,
          });
        })
        .finally(() => {
          _vm.loadingBtnNeo = false;
        });
    },
  },
  mounted() {
    this.$store.dispatch("restaurantes/getEmails").then((r) => {
      this.emails.internos = r ? r.internos : [];
      this.emails.reservas = r ? r.reservas : [];
      this.emails.zcierre = r ? r.zcierre : [];
      this.emails.notificaciones = r ? r.notificaciones : [];
      this.emails.contacto = r ? r.contacto : [];
    });
    if (this.$store.getters["app/restGestObj"].confGeneral) {
      this.general = this.$store.getters["app/restGestObj"].confGeneral;
      this.general.tiempoDomicilio =
        this.$store.getters["app/restGestObj"].tiempoDomicilio;
      this.general.tiempoRecoger =
        this.$store.getters["app/restGestObj"].tiempoRecogida;
      this.general.formasPagoDomicilio =
        this.$store.getters["app/restGestObj"].formasPagoDomicilio;
      this.general.formasPagoRecoger =
        this.$store.getters["app/restGestObj"].formasPagoRecoger;
    }
    if (this.$store.getters["app/restGestObj"].personalizacion) {
      this.personalizacion =
        this.$store.getters["app/restGestObj"].personalizacion;
    }
    this.getNeo();
    Promise.all([this.getTickets(), this.getOrdenadores()]).then(() => {
      this.datos = this.$store.state.restaurantes.impresorasRest;
      this.ordenadoresSeleccionados =
        this.$store.state.restaurantes.ordenadoresRest;
    });
  },
};
</script>